// extracted by mini-css-extract-plugin
export var circle = "_fg-1";
export var exitConfirmationModal = "_fg-5";
export var iframe = "_fg-0";
export var offline = "_fg-3";
export var online = "_fg-2";
export var workstationSelectError = "_fg-4";